import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { truncate } from '../../lib/functions';
import { COMMIT_NAMESPACE } from '../../actions';
import Payment from '../../lib/payment';
import Purchase from '../../lib/purchase';

import DepositPayment from '../../containers/organizer-commit/deposit-payment.container';
import EstimatedPayment from '../../containers/commit-form/estimated-payment.container';
import FooterPoweredBy from '../../containers/footer-powered-by.container';
import LinkWithPopover from '../link-with-popover';
import LikelyShare from '../../containers/commit-form/likely-share.container';
import MaxAllowedShare from '../../containers/commit-form/maximum-allowed-share.container';
import PaymentSchedule from '../../containers/member-payments-schedule-link.container';
import PurchaseImage from '../../../containers/purchase-image.container';
import { SMALL_LANDSCAPE } from '../../lib/image-versions';
import MultiCurrencyNotice from '../../containers/multi-currency-notice.container';

class CommitRightHandSide extends Component  {
  get showingDeposit() {
    return this.props.showingDeposit;
  }

  wontBeChargedNotice() {
    const { purchase: { payments } } = this.props;

    const hasPaymentsCharged = payments.length > 0 && payments.some((payment) => {
      const { status } = payment;
      return !Payment.isActive(status) && !Payment.isPending(status);
    });

    if (this.showingDeposit || hasPaymentsCharged) return null;

    return (
      <p className="small-print">
        <span role="img" aria-label="" className="mr-2">☝🏻</span>
        <FormattedMessage
          id="commitRHS.wontBeChargedNotice"
          defaultMessage="This won't be charged until enough group members commit to fund the full purchase amount."
        />
      </p>
    );
  }

  renderDepositDetails() {
    if (!this.showingDeposit) return null;

    return (
      <div className="row mt-3">
        <div className="col-12">
          <DepositPayment />
        </div>
      </div>
    );
  }

  renderEstimatedPayment() {
    if (this.showingDeposit) return null;
    return (
      <div className="row mt-3">
        <div className="col-12">
          <EstimatedPayment />
        </div>
      </div>
    );
  }

  renderPurchaseDetails() {
    const { purchase } = this.props;
    if (!purchase.product.description) return null;

    return (
      <LinkWithPopover
        name="product-description"
        text={
          <FormattedMessage
            id="commitRHS.moreInfo"
            defaultMessage="More info"
          />
        }
        placement="left"
      >
        <div className="product-description mt-3">
          <h4>{purchase.product.name}</h4>
          <p className="small-print mb-3"
            dangerouslySetInnerHTML={{
              __html: Purchase.renderProductDescription(truncate(purchase.product.description, 600))
            }}/>
        </div>
      </LinkWithPopover>
    );
  }

  render() {
    const { purchase } = this.props;

    return (
      <div className="purchase-summary">
        <div className="row">
          <div className="col-12">
            <div className="image-wrapper">
              <PurchaseImage version={SMALL_LANDSCAPE} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <h4 className="mt-3" title={purchase.product.name}>
              {truncate(purchase.product.name, 50)}
            </h4>
            {this.renderPurchaseDetails()}
          </div>
        </div>

        {this.renderDepositDetails()}

        <div className="row mt-3">
          <div className="col-12">
            <MaxAllowedShare />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12">
            <LikelyShare deposit={this.showingDeposit} />
          </div>
        </div>

        {this.renderEstimatedPayment()}

        {!this.showingDeposit && (
          <div className="row mt-3 mb-2">
            <PaymentSchedule
              constraints={[{ elem: '.purchase-summary', pin: ['right'] }]}
              namespace={COMMIT_NAMESPACE}
            />
          </div>
        )}

        <MultiCurrencyNotice />

        {this.wontBeChargedNotice()}

        <FooterPoweredBy />

      </div>
    );
  }
};

export default CommitRightHandSide;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/commit-right-hand-side.js